import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function TopWhenRefresh () {
  const { pathname } = useLocation();

  // Make the browser NOT restore the previous scroll position on reload
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  // Always scroll to top on every route change (and on first mount)
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}
